import $ from 'jquery';
import {Swiper, Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);

const testimonialSwiper = new Swiper('.swiper-testimonial', {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    autoplay: {
        delay: 4000,
    },
    navigation: {
        prevEl: $('.testimonial-swiper-button-prev')[0],
        nextEl: $('.testimonial-swiper-button-next')[0],
    },
});
